<template>
    <section>
      <b-button variant="primary" @click="$bvModal.show('modal-group')" v-if="show">
        <b-icon icon="collection-fill" aria-hidden="true"></b-icon> Criar Ilha
      </b-button>
  
      <b-modal
        id="modal-group"
        title="Cadastrar Ilha"
        centered
        size="sm"
        @hide="resetForm"
      >
        <b-row class="justify-content-md-center">
          <b-col>
            <label for="input-nome">Nome:</label>
            <b-input-group>
              <template #prepend>
                <b-input-group-text><b-icon icon="tag-fill"></b-icon></b-input-group-text>
              </template>
              <b-form-input
                v-model="nome"
                id="input-nome"
                :state="nomeState"
                trim
                placeholder="Digite o nome do grupo"
                @blur="touchedNome = true"
                :class="{'is-invalid': !nomeState && touchedNome}"
              ></b-form-input>
              <b-form-invalid-feedback id="input-live-feedback" v-if="!nomeState && touchedNome">
                Preencha um Nome!
              </b-form-invalid-feedback>
            </b-input-group>
          </b-col>
        </b-row>
  
        <b-row class="justify-content-md-center">
          <b-col>
            <label for="select-queues">Filas:</label>
            <b-input-group>
              <template #prepend>
                <b-input-group-text><i class="fas fa-users"></i></b-input-group-text>
              </template>
              <b-form-select
                v-model="selectedQueues"
                :options="queueOptions"
                multiple
                id="select-queues"
                :state="queuesState"
                style="height: 184px"
                :class="{'is-invalid': !queuesState && touchedQueues}"
                @blur="touchedQueues = true"
              >
              </b-form-select>
              <b-form-invalid-feedback v-if="!queuesState && touchedQueues">
                Selecione pelo menos uma fila!
              </b-form-invalid-feedback>
            </b-input-group>
          </b-col>
        </b-row>
  
        <template #modal-footer>
          <div class="float-right">
            <b-button
              variant="danger"
              size="sm"
              @click="handleCancel"
            >
              Cancelar
            </b-button>
            <b-button
              variant="primary"
              size="sm"
              @click="saveGroup"
            >
              Salvar
            </b-button>
          </div>
        </template>
      </b-modal>
    </section>
  </template>
  
  <script>
export default {
  name: "FormGroup",
  data() {
    return {
      nome: null,
      show: true,
      queueOptions: [],
      selectedQueues: [],
      touchedNome: false,
      touchedQueues: false
    };
  },
  methods: {
    saveGroup() {
      this.touchedNome = true;
      this.touchedQueues = true;

      if (this.nome && this.selectedQueues.length > 0) {
        const queuesAsStrings = this.selectedQueues.map(queue => queue.toString());

        fetch('/createGroup', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            name: this.nome,
            queues: queuesAsStrings
          })
        })
        .then(response => response.json())
        .then(data => {
          Swal.fire({
            toast: true,
            position: "top-end",
            type: "success",
            title: "Grupo criado com sucesso",
            showConfirmButton: false,
            timer: 1500,
          });
          this.$bvModal.hide('modal-group');
          this.$emit('setGroup', { name: this.nome, queues: queuesAsStrings });
          this.resetForm();
        })
        .catch(error => {
          Swal.fire({
            toast: true,
            position: "top-end",
            type: "error",
            title: "Falha ao criar o Grupo",
            showConfirmButton: false,
            timer: 1500,
          });
        });
      }
    },
    fetchQueues() {

      fetch('user/listQueueUser')
        .then(response => response.json())
        .then(data => {
          this.queueOptions = data.map(queue => ({
            value: queue.id,
            text: queue.name
          }));
        })
        .catch(error => {
          console.error('Error fetching queues:', error);
        });
    },
    handleCancel() {
      this.resetForm();
      this.$bvModal.hide('modal-group');
    },
    resetForm() {
      this.nome = null;
      this.selectedQueues = [];
      this.touchedNome = false;
      this.touchedQueues = false;
    }
  },
  computed: {
    nomeState() {
      return (this.nome !== null && this.nome.trim() !== '');
    },
    queuesState() {
      return (this.selectedQueues.length > 0);
    }
  },
  mounted() {
    this.fetchQueues();
  }
};
</script>



  <style scoped>
  </style>
  